import cn from 'classnames';
import type { ProductComponentAbstractProps } from 'containers/payments/ProductsListAbstract';
import React, { useCallback } from 'react';

import { plansDescription } from 'components/complex/payments/Product/constants';
import { Border, BorderTypeEnum } from 'components/domains/common/Border';

import dateToString from 'utils/dateToString';

import { DiscountLabel } from '../DiscountLabel';
import { CurrencyEnum } from '../FormattedPrice';
import { ProductSubTitle } from '../ProductSubTitle';
import { ProductTitle } from '../ProductTitle';

import styles from './styles.module.scss';

export interface ProductProps extends ProductComponentAbstractProps {
  className?: string;
  hideDiscount?: boolean;
  priceInterval?: string;
}

// eslint-disable-next-line complexity
export const Product: React.FC<ProductProps> = ({
  className,
  onClick,
  product,
  isSelected,
  nextPayment,
  hideDiscount,
  priceInterval,
}) => {

  const {
    currency,
    price,
    discount,
    discount_price: discountPrice,
    interval,
  } = product.prices[0];

  const {
    title,
  } = product;

  const isCurrent = product.is_current && product.is_paid;

  const onClickHandler = useCallback(() => {
    if (isSelected || isCurrent) {
      return;
    }

    onClick(product);
  }, [isSelected, isCurrent, onClick, product]);

  let status = isSelected ? BorderTypeEnum.SELECTED : BorderTypeEnum.NOT_ACTIVE;

  const isShowDiscount = !isCurrent && discount !== null;
  let showedPrice = null;

  if (
    isShowDiscount &&
    interval !== 'lifetime' &&
    interval !== 'month' &&
    // @ts-ignore
    interval !== 'year-gift'
  ) {
    showedPrice = isShowDiscount && discountPrice !== null ? discountPrice : price;
  }

  if (isCurrent) {
    status = BorderTypeEnum.DISABLED;
  }

  // const nextPayment = new Date().toDateString();
  let subText = plansDescription[interval];
  if (isCurrent && nextPayment) {
    subText = `Your current plan, next payment ${dateToString(nextPayment)}`;
  } 
  else if (isCurrent && !nextPayment) {
    subText = 'Your current plan';
  }

  return (
    <Border type={status} onClick={onClickHandler} className={className}>
      <div
        className={cn(styles.container, {
          [styles.selected]: false,
          [styles.currentPlan]: isCurrent,
        })}
      >
        {!hideDiscount && discount && !isCurrent ? (
          <DiscountLabel discount={discount} />
        ) : null}
        <ProductTitle
          currency={currency}
          price={price}
          discountPrice={discountPrice}
          name={title}
          isCurrent={isCurrent}
        />
        <ProductSubTitle
          name={subText}
          currency={currency}
          interval={interval}
          isCurrent={isCurrent}
          price={Number(showedPrice)}
          priceInterval={priceInterval}
        />
      </div>
    </Border>
  );
};

Product.displayName = 'Payments/Product';
